import { HandleBusinessTimeType } from 'types/store'
import { isNumerics, isValidDomainSacri, isValidPhoneNumber, isValidUrlString } from './validator'
import { DayOfWeekType } from './daysOfWeek'

// 営業時間がすべて入力済みで、曜日もすべて選択済みかどうか
export const isCompleteStoreSettings = (value: {
  businessTimes: HandleBusinessTimeType[]
  remainingDaysOfWeek: DayOfWeekType[]
}): boolean => {
  const { businessTimes, remainingDaysOfWeek } = value
  if (businessTimes.length === 0) return false
  return (
    !businessTimes.some((businessTime) => Object.values(businessTime).some((time) => time === '')) &&
    remainingDaysOfWeek.length === 0
  )
}

export const isCompleteStoreInformation = (value: {
  imageUrls: string[]
  name: string
  nameKana: string
  firstPostalCode: string
  secondPostalCode: string
  state: string
  city: string
  street: string
  phoneNumber: string
  hasEatingArea: string
  status: string
  homepage: string
  twitter: string
  instagram: string
  facebook: string
  line: string
  feeRate: string
  webHostName: string
}): boolean => {
  return (
    value.imageUrls.length !== 0 &&
    value.name !== '' &&
    value.nameKana !== '' &&
    value.firstPostalCode !== '' &&
    value.firstPostalCode.length === 3 &&
    value.secondPostalCode !== '' &&
    value.secondPostalCode.length === 4 &&
    isNumerics(value.firstPostalCode) &&
    isNumerics(value.secondPostalCode) &&
    value.state !== '' &&
    value.city !== '' &&
    value.street !== '' &&
    isValidPhoneNumber(value.phoneNumber) &&
    value.hasEatingArea !== '' &&
    value.status !== '' &&
    isValidUrlString(value.homepage) &&
    isValidUrlString(value.twitter) &&
    isValidUrlString(value.instagram) &&
    isValidUrlString(value.facebook) &&
    isValidUrlString(value.line) &&
    value.feeRate !== '' &&
    isValidDomainSacri(value.webHostName)
  )
}

export const hasTouchScreen = (): boolean => {
  if (navigator.maxTouchPoints > 0) {
    return true
  }
  if (window.matchMedia('(pointer:coarse)').matches) {
    return true
  }
  if ('orientation' in window) {
    return true
  }
  return false
}

export const isPcDevice = (): boolean => {
  const ua = window.navigator.userAgent.toLowerCase()
  if (ua.indexOf('iphone') > 0 || ua.indexOf('ipod') > 0 || (ua.indexOf('android') > 0 && ua.indexOf('mobile') > 0)) {
    return false
  } else if (ua.indexOf('ipad') > 0 || ua.indexOf('android') > 0) {
    // iOS12 まで
    return false
  } else if (ua.indexOf('ipad') > -1 || (ua.indexOf('macintosh') > -1 && 'ontouchend' in document)) {
    // iOS13 以降
    return false
  } else {
    return true
  }
}

export const getBrowserName = (): string => {
  const userAgent = window.navigator.userAgent.toLowerCase()
  if (userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1) {
    return 'ie'
  } else if (userAgent.indexOf('edge') != -1) {
    return 'edge'
  } else if (userAgent.indexOf('chrome') != -1) {
    return 'chrome'
  } else if (userAgent.indexOf('safari') != -1) {
    return 'safari'
  } else if (userAgent.indexOf('firefox') != -1) {
    return 'firefox'
  } else if (userAgent.indexOf('opera') != -1) {
    return 'opera'
  } else {
    return ''
  }
}

export const isFilledCouponRequiredFields = (
  name: string,
  code: string,
  couponCodes: string[],
  description: string,
  discountAmount: number,
  discountRate: number,
  maxDiscount: number,
  minAmount: number,
  storeIds: string[] | undefined
): boolean => {
  return (
    name !== '' &&
    !couponCodes.includes(code) &&
    code.length !== 8 &&
    description !== '' &&
    (discountAmount > 0 || discountRate > 0) &&
    // 割引種別がパーセント割引であれば割引上限額が指定されている
    (discountAmount > 0 || (discountRate > 0 && maxDiscount !== 0)) &&
    // 最小決済金額が指定されている（0ではない）、または、50円より大きいかつ定額割引金額より大きい
    (minAmount === 0 || (minAmount !== 0 && minAmount > 50 && minAmount > discountAmount)) &&
    // 利用可能店舗が指定されているならば、店舗名未選択がないこと
    (storeIds ? storeIds.every((storeId) => storeId !== '') : true)
  )
}
